document.addEventListener('DOMContentLoaded', function (dom) {
    const comparisonTable = dom.target.querySelector('.js-comparison-table')
    if (comparisonTable) {
        const th = comparisonTable.querySelectorAll('.js-cell-header');
        if (th.length) {
            let labelTexts = [];
            th.forEach((e, i) => {
                let href = ''
                const link = e.querySelector('a');
                const title = e.querySelector('.title__title');
                const more = e.querySelector('.title__more');
                let output = "";
                if (link != null && link.tagName === 'A') {
                    href = link.href
                    output += title.textContent + ' :\n' + more.textContent
                } else {
                    output = e.textContent.trim() + ' :\n';
                }
                labelTexts.push({text: output, link: href});
            })
            const td = comparisonTable.querySelectorAll('.table__cell.js-cell-no-header');
            if (td.length) {
                td.forEach((e, i) => {
                    e.setAttribute('data-label', labelTexts[i % th.length].text)
                    if (i % th.length === th.length - 1) {
                        e.classList.add('table__cell--col-last')
                    }
                    const link = labelTexts[i % th.length].link;
                    if (link !== '') {
                        e.addEventListener('click', function () {
                            window.location = link
                        })
                    }
                })
            }
        }
    }
})
